import { displayDateFormat } from '@config/i18n';
import { format, parseISO } from 'date-fns';

/**
 * A API troca datas `YYYY-MM-DD` "flutuantes" (sem timezone). `new Date(iso)`
 * nativo interpreta isso como UTC meia-noite, deslocando um dia em fusos
 * negativos (ex.: BRT). `parseISO` do date-fns trata como data local — é o
 * que evita esse desvio.
 */
export function parseApiDate(iso: string | null | undefined): Date | null {
  return iso ? parseISO(iso) : null;
}

export function toApiDate(date: Date | null | undefined): string | null {
  return date ? format(date, 'yyyy-MM-dd') : null;
}

export function formatDisplayDate(iso: string | null | undefined, locale: string): string {
  const date = parseApiDate(iso);
  if (!date) return '';
  return format(date, displayDateFormat(locale));
}
